const changeAutomaticEmailsStr = {
  toastr: 'Datos cambiados'
};

export default changeAutomaticEmailsStr;
